module.exports = __webpack_public_path__ + "img/chadle_adv_16.c17e2bf5.png";